import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';import InputAdornment from '@mui/material/InputAdornment';
import Addproducts from './Addproducts';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import AddCustomerbox from './Addcustomer';
import Checkbox from '@mui/material/Checkbox';
import Customershipping from './Customershipaddress';
import Customerbilling from './Customeraddress';
import AttachmentIcon from '@mui/icons-material/Attachment';
let strCust=[{title:'Add Customer',year:'0',rowindex:'-1'}];
let strProd=[{title:'Add Product',year:'0',rowindex:'-1'}];
const strProduct=[];
const strProductdeflt='';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
const useStyles = styled(theme => ({
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
container: {  
    maxHeight: 440,  
  }, 
  table: {
    minWidth: 750,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
export default class salesinvoice extends Component {
	constructor(props) {
    super();
	  var strdob=new Date();
	 var month="";
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	  var strgoods=new Date();
   strgoods.setDate(strgoods.getDate() + 3);
	 this.state = {sin_id:0,sinid:'',sinidarray:[],open:false,redirect:false,details:'',erropen:false,customerselectdtags:[],custid:'',salesshippingamt:"0.00",salesdiscount:"0.00",estimateid:0,paybalamt:0,cu_creditlimit: '',
	   invoicedate:Date.now(),invoicedate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),invoiceduedate:strgoods,invoiceduedate1:strgoods.getFullYear() + '-' + month + '-' +strgoods.getDate(),taxdata:[],ledgerdata:[],pvdata:[],prodid:'',cuid:'',selectedproduct:[],
	 selectedcustomerexchange:[],prodarrauto:[],showField:-1,newpcid:0,comments:'',termscond:'',reference:'',errormessage:'',previocn:"",sin_file:'',custdefaultprice:'4',profit:"0.00",subtotal:"0.00",isdraft:false,errortype:"error",invoiceno:'',taxbrkupsarr:[],taxsumarr:[],
	 grandtotal:"0.00",copy:'',primarytaxid:'',primaryledgerid:'',
	 	 pagename:'',btndisabled:false,submitbtn:"Save",cu_contactname:'',customerarray:[],customerrauto:[],custtags:'',customer:[],custarray:[],billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'', 
      shippingaddress1:'',shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',productarray:[],productrauto:[],prodtags:'',product:[],prodarray:[],productselectdtags:[],description:'',ledgername:'',selectedcustomerid:'',country:'',
	 countrylabel:'No Tax',ledger:'',ledgerlabel:'',productselectdval:[],productselectdtags:'',}
	  this.onTagscustomerexchange = this.onTagscustomerexchange.bind(this);
	  this.onTagsproductexchange = this.onTagsproductexchange.bind(this);
   this.updateDonenewParent = this.updateDonenewParent;
      this.insertcustomerParent = this.insertcustomerParent;
	    this.updatProductParent = this.updatProductParent;
}
updateDonenewParent = (text) => {
this.onloadustomerbyid(this.state.cuid);
	}
 onFileChange=(e) =>{
	      let imageFile = e.target.files[0];
	   if (!imageFile.name.match(/\.(pdf)$/)) {
  alert( 'Please select valid file (pdf).' );
    return false;
  }else{
        this.setState({ imgCollection: e.target.files })
  }
    }
	insertcustomerParent = (childData) => {
	 this.setState({ custid:childData,cuid:childData});		  
	//alert(localStorage.getItem("newcuid")) 
   this.onloadustomerbyid(childData);
 }
 updatProductParent= (childData) => {
	 this.setState({ pdid:childData,});		  
	//alert(localStorage.getItem("newcuid")) 
 this.onloadProductid(childData);
 }
handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  }
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;	  
	 this.setState({[nam]: val},()=>{
		   if(nam==="salesshippingamt")
{
this.Taxcalculate();
}
});	
}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
componentWillMount() {
	document.title = "Isifol Account - Sales Invoice";
if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			  this.ledgerbind(); 
this.GetTermsAndNotes();
this.BusinessSetting() ;this.GetBusinessSettingLedger();
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		    this.props.parentdasCallback(
            "Sales Invoice~"
        );
 let search = window.location.href;
    let Copy = this.getParameterByName('copy', search);	
if(Copy!==null){	
this.setState({copy:Copy});
}
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=2')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
          this.ledgerbind(); 
this.GetTermsAndNotes();
this.BusinessSetting() ;this.GetBusinessSettingLedger();
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
GetBusinessSettingLedger() {
  axios.get(localStorage.getItem("ISIurl") +'ajaxbusinesssetting.php?action=getall&bs_page=1&bs_cmp_id=' +localStorage.getItem('ISIcmpid') +'&bs_id=3')
  .then(resp => {
    if (resp.data.length > 0) {
this.setState({le_ledgername:resp.data[0]["bs_value"]});
    }
  });
}
GetTermsAndNotes(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesestimate.php?action=gettermsandnotes&ao_id=19,16&cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => { 
  let note = '', terms='';
   resp.data.forEach(item => {
        if (item.ao_id === "16") {
          note = item.ao_description;
        } else if (item.ao_id === "19") {
          terms = item.ao_description;
        }
      });
	this.setState({
		comments:note,
		termscond:terms,
		 ColumnData: resp.data,  
	})
  })
}
EstimateViewmore(inesid) {
    axios.get(localStorage.getItem("ISIurl") + 'ajaxsalesestimate.php?action=getall&se_status=1,2&se_cmp_id='+localStorage.getItem("ISIcmpid")+'&se_id=' + inesid)
        .then(resp => {
            if (resp.data.length > 0) {
              const items = {
        title:resp.data[0].cu_businessname,
          year:resp.data[0].se_cu_id,
        };
		let strvalue=false;
		if(resp.data[0].se_status=="1")
		{
			strvalue=true;
		}
                this.setState({se_id:resp.data[0].se_id,estimateid:resp.data[0].se_id,
                    custid:resp.data[0].se_cu_id,
					  cuid:resp.data[0].se_cu_id,
					  reference:resp.data[0].se_reference,
					  isdraft:strvalue,invoiceno:resp.data[0].se_quotenumber,
					  salesshippingamt:resp.data[0].se_shippingcharges,
                    selectedcustomerexchange:items,
					termscond:resp.data[0].se_termsandconditions,
					comments:resp.data[0].se_comments,
                },()=>{
				});
				this.EstimateProductapicall(inesid)
				 this.onloadustomerbyid(resp.data[0].se_cu_id);
            } else {
                this.setState({ estimateData: []});
            }
        });
}
EstimateProductapicall(seoid){
	axios.get(localStorage.getItem("ISIurl")+'ajaxestimateproduct.php?action=getall&eop_se_id='+seoid)
  .then(resp => { 
let oldOptionspvdata=[]; 
let newrow= {"rowindex":resp.data.length,"pr_id":"","eop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","taxper":"0.00","taxid":this.state.primarytaxid,"pr_isdeleted":"0","salesprice":"0.00","costtotal":"0","prodsel":[],"prodtax":[],
	"total":"0.00",showField: resp.data.length}
    if(resp.data.length>0){
			  oldOptionspvdata=resp.data
			  let index=0;
			  oldOptionspvdata.forEach(eachrep => {
					eachrep.rowindex=index;
					eachrep.prodsel={"title":eachrep.pr_description,"year":eachrep.pr_id};
index++;
				});
		}	
	  this.setState({pvdata: oldOptionspvdata.concat([newrow])},()=>{this.Taxcalculate();
	  });
    });
}
onloadProductid(pdid){
	let discal=0,strdisamt=0,costdiscnt=0;
	let id=this.state.prodrowindex;
	if(pdid!="")
	{
	axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=productautoextender&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_id='+pdid+'&defaultprice='+this.state.custdefaultprice)
  .then(resp => {  
   if(resp.data.length>0){
   const items = {
        title:resp.data[0]["title"]+" ("+resp.data[0]["pr_code"]+")",
          year:resp.data[0].year,
        };
		let optionsRep = this.state.pvdata;
		 optionsRep.sort((a, b) => a.rowindex > b.rowindex ? 1 : -1).forEach(eachrep => {
       if (eachrep.rowindex === id)
	   {
		    let strtaxvalue=((parseFloat(resp.data[0]["price"])*Number(1))*parseFloat( resp.data[0]["dwt_percentage"]))/100;
  let stramount=(parseFloat( resp.data[0]["price"])*Number(1))+parseFloat(strtaxvalue);
 let strdisamt=(parseFloat(resp.data[0]["price"])-parseFloat(discal));
  let strcosttaxvalue=(((parseFloat( resp.data[0]["pr_costprice"])*Number(1))*parseFloat( resp.data[0]["dwt_percentage"]))/100).toFixed(2);
  let strcostamount=(parseFloat( resp.data[0]["pr_costprice"])*Number(1))+parseFloat(strtaxvalue);
 let strcostdisamt=(parseFloat(resp.data[0]["pr_costprice"])-parseFloat(discal));
			   eachrep.pr_code= resp.data[0]["pr_code"];
			   eachrep.pr_description= resp.data[0]["pr_description"];
		       eachrep.salesprice= parseFloat(resp.data[0]["price"]).toFixed(2);
			   eachrep.costtotal= parseFloat(strcostdisamt).toFixed(2);
			    eachrep.pr_costprice= parseFloat(resp.data[0]["pr_costprice"]).toFixed(2);
			   eachrep.pr_quantityinhand= resp.data[0]["pr_quantityinhand"];
		      eachrep.tax= (strtaxvalue).toFixed(2);	  
			    eachrep.pr_tx_id= resp.data[0]["pr_tax_id"]+"~"+strtaxvalue;
		       eachrep.le_ledgername=resp.data[0]["ledgername"];
		       eachrep.qty= "1"; 
			   eachrep.taxid= resp.data[0]["pr_tax_id"];
			   eachrep.pr_id=resp.data[0]["year"];
			   eachrep.esprodid=resp.data[0]["year"];
			    eachrep.taxper=resp.data[0]["dwt_percentage"];
			   eachrep.proddiscount= resp.data[0]["discount"];
		    eachrep.pr_isdeleted= "0";
			 eachrep.prodsel= items;
		     eachrep.proddiscount=discal;
		      eachrep.unit= resp.data[0]["pr_unit"];
		   eachrep.total= parseFloat(stramount).toFixed(2);
		 //   eachrep.amount= Number(stramount).toFixed(2);
		    eachrep.amount= Number(strdisamt).toFixed(2);
	   }
		 });
		 	id=parseFloat(id)+1;
this.setState({pvdata: optionsRep.concat([{"rowindex":id,"pr_id":"","eop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","taxper":"0.00","taxid":this.state.primarytaxid,"pr_isdeleted":"0","salesprice":"0.00","costtotal":"","prodsel":[],"prodtax":[],
	"total":"0.00",showField: id}]), selectedproduct:items},()=>{
		this.Taxcalculate();
	})
   }
  });
	}
}
SalesinvoiceViewmore(Sinid) {
if(Sinid!==null)
{
  axios.get(localStorage.getItem("ISIurl") + 'ajaxsalesinvoice.php?action=getall&sin_cmp_id='+localStorage.getItem("ISIcmpid")+'&sin_id=' + Sinid)
        .then(resp => {
            if (resp.data.length > 0) {
              const items = {
        title:resp.data[0].cu_businessname,
          year:resp.data[0].sin_cu_id,         
        };
		let strvalue=false;
		if(resp.data[0].sin_status=="1")
		{
			strvalue=true;
		}
                this.setState({sin_id:resp.data[0].sin_id,
                    custid:resp.data[0].sin_cu_id,
					  cuid:resp.data[0].sin_cu_id,
					  reference:resp.data[0].sin_reference,
					   invoicedate:resp.data[0].sin_invoicedate,
					  invoicedate1:resp.data[0].sin_invoicedate,
					  invoiceduedate:resp.data[0].sin_invoiceduedate,
					  invoiceduedate1:resp.data[0].sin_invoiceduedate,
					  isdraft:strvalue,invoiceno:resp.data[0].sin_invoiceno,
					  salesshippingamt:resp.data[0].sin_shippingcharges,
                    selectedcustomerexchange:items,
					termscond:resp.data[0].sin_termsandconditions,
					comments:resp.data[0].sin_comments,
                },()=>{
					let strname="";
		   if(this.state.invoiceno!=="")
		   {
			  strname+="Sales Invoice: "+ this.state.invoiceno
		   }
	  this.props.parentdasCallback(
           strname+"~"
        );
				});
				this.Productapicall(Sinid)
				 this.onloadustomerbyid(resp.data[0].sin_cu_id);
            } else {
                this.setState({ estimateData: []});
            }
        });
}
}
Productapicall(sinid){
	axios.get(localStorage.getItem("ISIurl")+'ajaxsaleinvoiceproduct.php?action=getall&sorting=iop_id&iop_sin_id='+sinid)
  .then(resp => { 
let oldOptionspvdata=[]; 
let newrow= {"rowindex":resp.data.length,"pr_id":"","iop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","pr_isdeleted":"0","taxper":"0.00","taxid":this.state.primarytaxid,"salesprice":"0.00","costtotal":"0","prodsel":[],
	"total":"0.00",showField: resp.data.length}
    if(resp.data.length>0){
			  oldOptionspvdata=resp.data
			  let index=0;
			  oldOptionspvdata.forEach(eachrep => {
					eachrep.rowindex=index;
					eachrep.prodsel={"title":eachrep.pr_description,"year":eachrep.pr_id};
index++;
				});
		}	
	  this.setState({pvdata: oldOptionspvdata.concat([newrow])},()=>{this.Taxcalculate();
	  });
    });
}
  Usergetdata() {
		axios.get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=1&bs_id=3&bs_cmp_id=' + localStorage.getItem("ISIcmpid"))
	   .then(resp => {
            if (resp.data.length > 0) {
				 this.setState({ primaryledgerid:resp.data[0].bs_value,},()=>{
	 let search = window.location.href;
    let Sinid = this.getParameterByName('sinid', search);
	 let in_esid = this.getParameterByName('in_esid', search);
if(Sinid!==null)
{
	this.SalesinvoiceViewmore(Sinid);
	}
else if(in_esid!==null)
{ 
	this.EstimateViewmore(in_esid);
}
	else {
	   this.setState({ 
	 pvdata: [{"rowindex":this.state.newpcid,"pr_id":"","iop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","pr_isdeleted":"0","taxper":"0.00","taxid":this.state.primarytaxid,"salesprice":"0.00","costtotal":"0","prodsel":[],
	"total":"0.00",showField: this.state.newpcid}],});
	}	
	   });
			}
	   });
 }
 onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/Adminsalesinvoice'});
 }
handleinvoicedate = (date) => {
  let invDate = new Date(date);
  let dueDate = new Date(invDate);
  let settingValue = String(this.state.businesssettingvalue || "");
  let parts = settingValue.split(",");
  let type = parts[0]; 
  let days = parseInt(parts[1] || "0");
  if (type === "1") {
    dueDate.setDate(invDate.getDate() + (days > 0 ? days : 3));
  } else if (type === "2") {
    dueDate = new Date(invDate.getFullYear(), invDate.getMonth() + 1, 0);
  } else if (type === "3") {
    dueDate = new Date(invDate);
  }
  this.setState({
    invoicedate: dayjs(invDate),
    invoicedate1:
      invDate.getFullYear() +
      "-" +
      String(invDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      invDate.getDate(),
    invoiceduedate: dayjs(dueDate),
    invoiceduedate1:
      dueDate.getFullYear() +
      "-" +
      String(dueDate.getMonth() + 1).padStart(2, "0") +
      "-" +
      dueDate.getDate(),
  });
};
BusinessSetting() {
  axios
    .get(
      localStorage.getItem("ISIurl") +
        "ajaxbusinesssetting.php?action=getall&bs_page=1&bs_cmp_id=" +
        localStorage.getItem("ISIcmpid") +
        "&bs_id=1"
    )
    .then((resp) => {
      if (resp.data.length > 0) {
        let settingValue = String(resp.data[0]["bs_value"] || "");
        this.setState({ businesssettingvalue: settingValue }, () => {
         // console.log("Business Setting Value:", this.state.businesssettingvalue);
        });
        let today = new Date();
        let invDate = new Date(today);
        let dueDate = new Date(today);
        let parts = settingValue.split(",");
        let type = parts[0];
        let days = parseInt(parts[1] || "0");
        if (type === "1") {
          dueDate.setDate(today.getDate() + (days > 0 ? days : 3));
        } else if (type === "2") {
          dueDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        } else if (type === "3") {
          dueDate = new Date(today);
        }
        this.setState({
          invoicedate: dayjs(invDate),
          invoicedate1:
            invDate.getFullYear() +
            "-" +
            String(invDate.getMonth() + 1).padStart(2, "0") +
            "-" +
            invDate.getDate(),
          invoiceduedate: dayjs(dueDate),
          invoiceduedate1:
            dueDate.getFullYear() +
            "-" +
            String(dueDate.getMonth() + 1).padStart(2, "0") +
            "-" +
            dueDate.getDate(),
        });
      }
    });
}
  Customerbillingaddbox(val){
        this.setState({ cuid: val });  
         setTimeout(() => this.refs.BillingAddCustomerbox.handleClickOpen(),500);
      }
   Customershippingaddbox(val){
        this.setState({ cuid: val });  
         setTimeout(() => this.refs.ShippingAddCustomerbox.handleClickOpen(),500);
      }
	   handlAddProductopen = (val) => {
         this.refs.Addproducts.handleProdClose();    
}
handleCustomerInsertpopup= (e) => {
	  this.setState({ cuid: 0 },()=>{this.refs.AddCustomerbox.handleClickOpen()});  
}
  Discountpanelhide= (firstrow) => event  => { 
	   const updatedArray = [...this.state.pvdata];
	 updatedArray[firstrow].discpoppnl = "0";
	   this.setState({pvdata: updatedArray});
  }
  Discountelement= (firstrow) => event  => { 
    let nam = event.target.name;
  let val = event.target.value;
  const updatedArray = [...this.state.pvdata];
 if(nam==="discount") {
	 if(updatedArray[firstrow].discpoppnl==="0")
	 {
updatedArray[firstrow].discpoppnl = "1";
	 }
	 else{updatedArray[firstrow].discpoppnl = "0";}
}
this.setState({pvdata: updatedArray});
 }
  onEntertitle= (firstrow) => event  => {
let id=parseInt(firstrow)+1,prevrow=parseInt(this.state.pvdata.length)-1;
if(this.state.pvdata[prevrow].pr_description!=="")
{
	 this.setState({pvdata: this.state.pvdata.concat([{"rowindex":id,"pr_id":"","iop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","pr_isdeleted":"0","taxper":"0.00","taxid":this.state.primarytaxid,"salesprice":"0.00","costtotal":"0","prodsel":[],
	"total":"0.00",showField: id}]), selectedproduct:[]});
}		
 }
 myChangeHandlerPV = (firstrow) => event  => { 
		const re = /^[0-9.\b]+$/;
   let nam = event.target.name;
  let val = event.target.value;
   let optionsRep = this.state.pvdata;
  let strtotaldiscount="0";
  let id = this.state.showField;
  const updatedArray = [...this.state.pvdata];
if(nam==="pr_description")
		   {
		updatedArray[firstrow].pr_description = val;
		   }
		      if(nam==="popdiscount" || nam==="discount")
		   {
var strdisperl=parseFloat((parseFloat(val)/(parseFloat(updatedArray[firstrow].qty)*parseFloat(updatedArray[firstrow].salesprice)))*100).toFixed(1);
		updatedArray[firstrow].popdiscount = val;
  updatedArray[firstrow].discount = val;
  updatedArray[firstrow].popdiscountper = strdisperl;
		   }
		    if(nam==="popdiscountper")
		   {
var strval=parseFloat((parseFloat(updatedArray[firstrow].salesprice)*parseFloat(updatedArray[firstrow].qty)*parseFloat(val))/100).toFixed(2);
		updatedArray[firstrow].popdiscountper = val;
  updatedArray[firstrow].discount = strval;
  updatedArray[firstrow].popdiscount = strval;
		   }
if(nam==="le_ledgername") {
updatedArray[firstrow].le_ledgername = val;
}
if(nam==="ledger") {
updatedArray[firstrow].ledger = val;
}
if(nam==="qty") {
updatedArray[firstrow].qty = val;
 var strdisperl=parseFloat((parseFloat(updatedArray[firstrow].discount)/(parseFloat(updatedArray[firstrow].qty)*parseFloat(updatedArray[firstrow].salesprice)))*100).toFixed(2);
  	updatedArray[firstrow].popdiscountper = strdisperl;
}
if(nam==="salesprice") {
	updatedArray[firstrow].salesprice = parseFloat(val).toFixed(2);
		 var strdisperl=parseFloat((parseFloat(updatedArray[firstrow].discount)/(parseFloat(updatedArray[firstrow].qty)*parseFloat(updatedArray[firstrow].salesprice)))*100).toFixed(2);
updatedArray[firstrow].popdiscountper = strdisperl;
}
if(nam==="pr_tx_id") {
let strarr= val.split('~');	
updatedArray[firstrow].pr_tx_id = val;	
updatedArray[firstrow].taxper = strarr[1];
	updatedArray[firstrow].taxid= strarr[0];
}
 let strtaxvalue=((((parseFloat(updatedArray[firstrow].salesprice)*parseFloat(updatedArray[firstrow].qty))-parseFloat(updatedArray[firstrow].discount))*parseFloat( updatedArray[firstrow].taxper))/100).toFixed(2);
 let stramount=(parseFloat(updatedArray[firstrow].salesprice)*parseFloat(updatedArray[firstrow].qty))+parseFloat(strtaxvalue)-parseFloat(updatedArray[firstrow].discount);
  let strcosttaxvalue=((((parseFloat(updatedArray[firstrow].pr_costprice)*parseFloat(updatedArray[firstrow].qty))-parseFloat( updatedArray[firstrow].discount))*parseFloat(updatedArray[firstrow].taxper))/100).toFixed(2);
  let strcostamount=((parseFloat(updatedArray[firstrow].pr_costprice)*parseFloat(updatedArray[firstrow].qty))+parseFloat(strtaxvalue))-parseFloat( updatedArray[firstrow].discount);
 updatedArray[firstrow].costtotal = parseFloat(strcostamount).toFixed(2);
  updatedArray[firstrow].tax = parseFloat(strtaxvalue);
 updatedArray[firstrow].total = parseFloat(stramount).toFixed(2);
  this.setState({pvdata: updatedArray},()=>{this.Taxcalculate();});
} 
onloadustomerbyid(cuid){
		 axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=getall&cu_cmp_id='+localStorage.getItem("ISIcmpid")+'&cu_id='+cuid)
  .then(resp => {  
   if(resp.data.length>0){
    this.setState({ 
   	 	custtags:resp.data[0].cu_contactname,
   	 	cu_creditlimit:resp.data[0].cu_creditlimit,
	   cuid:resp.data[0].cu_id,
	 billingaddress1:resp.data[0].cu_billingaddress1,
		   billingaddress2:resp.data[0].cu_billingaddress2,
		    billingcity:resp.data[0].cu_billingcity,
			 billingstate:resp.data[0].cu_billingstate,
			  billingpincode:resp.data[0].cu_billingpincode,
		   shippingaddress1:resp.data[0].cu_shippingaddress1,
		    shippingaddress2:resp.data[0].cu_shippingaddress2,
			shippingcity:resp.data[0].cu_shippingcity,
			shippingstate:resp.data[0].cu_shippingstate,	       
			   custdefaultprice:resp.data[0].cu_pricedefault,
			   shippingpincode:resp.data[0].cu_shippingpincode,
	paybalamt:resp.data[0].custbalance,
	country:resp.data[0].cu_co_id
	});
   }
  });
}   
onloadCustomerBind=(event)=>{
	 if(event.target.value.length > 0 )
	{
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcustomer.php?action=customerextender&cu_cmp_id='+localStorage.getItem("ISIcmpid")+'&cu_contactname='+event.target.value)
  .then(resp => { 
  const rowsArray = resp.data || [];
	 let strCust = [];
rowsArray.forEach((row, i) => {
		 const items = {
        title:row.title,
          year:row.year,
		  cuid:row.year,
		  rowindex:row.rowindex,
           cu_contactname:row.cu_contactname,
		 billingaddress1:row.cu_billingaddress1,
		 billingaddress2:row.cu_billingaddress2,
		 billingcity:row.cu_billingcity,
		  billingstate:row.cu_billingstate,
		   billingpincode:row.cu_billingpincode,
		  shippingaddress1:row.cu_shippingaddress1,
		 shippingaddress2:row.cu_shippingaddress2,
		 shippingcity:row.cu_shippingcity,
		  shippingstate:row.cu_shippingstate,
		   shippingpincode:row.cu_shippingpincode,
		 country:row.cu_co_id,
		 custdefaultprice:row.cu_pricedefault,
        };
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		 });
strCust.sort((a, b) => b.rowindex - a.rowindex);
		  this.setState({
  custarray: rowsArray,
  customerrauto: strCust
});
  });
	}else{
	this.setState({customerrauto:strCust});
	}
}
onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({custid:newTextValue})
	} 
}
onTagscustomerexchange = (event, values) => {
	if(values!==" " && values!==null && values.rowindex!="-1"){
		this.setState({
		custid:values.year,
		 cuid:values.year,paybalamt:values.dueamount,
	billingaddress1:values["billingaddress1"],
		   billingaddress2:values["billingaddress2"],
		    billingcity:values["billingcity"],
			 billingstate:values["billingstate"],
			  billingpincode:values["billingpincode"],
		   shippingaddress1:values["shippingaddress1"],
		    shippingaddress2:values["shippingaddress2"],
			shippingcity:values["shippingcity"],
			shippingstate:values["shippingstate"],	       
			   custdefaultprice:values["custdefaultprice"],
			   shippingpincode:values["shippingpincode"],
			   country:values["country"],
		selectedcustomerexchange:values})
	}
	else
	{
		 this.setState({ custid:'',cu_id:'',selectedcustomerexchange:[]})
	}
}
onSelectedTaxbyid(txid,arr){
		 axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=taxid&tx_id='+txid+'&tx_cmp_id='+localStorage.getItem("ISIcmpid"))
  .then(resp => {  
    let strarraytax=[];
   if(resp.data.length>0){
	var rowsArrayp = resp.data;
	 rowsArrayp.map((txrow, j) => {
	const taxitems = {
        taxname:txrow.tx_name,
         taxmid:txrow.tx_mainid,
		 taxper:txrow.dwt_percentage,
          taxamt:0 ,
		   taxablevalue:0
        };
		strarraytax.push(taxitems);
		});
		let strarray=Object.values(arr);
let mergedarray = strarraytax.map(function(item) {
   strarray.map(function(item2) {
      if (item.taxmid == item2.taxid) {

         let baseAmount = parseFloat(item2.total);
         let percent = parseFloat(item.taxper);

         let calculatedTax = ((baseAmount * percent) / 100).toFixed(2);

         item.taxamt = calculatedTax;         
         item.taxablevalue = baseAmount;     
      }
   });
   return item;
});
	this.setState({ taxbrkupsarr:mergedarray})
   }
  });
} 
onloadproductbyid(prid){
		 axios.get(localStorage.getItem("ISIurl")+'ajaxproduct.php?action=list&pr_id='+prid)
  .then(resp => {  
   if(resp.data.length>0){
	 const proditems = {
        title:resp.data[0].pr_name,
          year:resp.data[0].pr_id,
		  description:resp.data[0].pr_description,
		  ledgername:resp.data[0].le_ledgername,
		  quantity:resp.data[0].pr_quantity,
          price:resp.data[0].pr_costprice,
        };
	   this.setState({productselectdval:proditems,productselectdtags:resp.data[0].pr_name})
   }
  });
} 
onloadProductsBind=(event)=>{
	 if(event.target.value.length>0 ){
 axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=productautoextender&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_code='+event.target.value+'&defaultprice='+this.state.custdefaultprice)
  .then(resp => { 
  if(resp.data.length>0){
  this.setState({ produserarray:resp.data });
   var rowsArrayp = resp.data;
	 rowsArrayp.map((row, j) => {
		 const items = {
        title:row.title+" ("+row.pr_code+")",
          year:row.year,rowindex:row.rowindex,
           pr_code:row.pr_code, 
		   pr_description:row.pr_description,
		  ledgername:row.pr_ledger_id,
		   pr_tax_id:row.pr_tax_id,
		  quantity:row.pr_quantity,
          salesprice:row.price,
		  pr_costprice:row.pr_costprice,
		  taxper:row.dwt_percentage
        };
      const found = strProd.some(el => el.year === row.year);
		 if (!found) strProd.push(items);
		 });
		  strProd = strProd.sort((a, b) => a.rowindex < b.rowindex ? 1 : -1)
		   this.setState({prodarrauto:strProd})
  } 
  });
  }
}
 onInputprodChange = (rows) =>(event, newTextValue) => {
if(newTextValue!==" "){
	const updatedArray = [...this.state.pvdata];
	updatedArray[rows].esprodid = newTextValue;
  this.setState({pvdata:updatedArray})
}  
 }
 onTagsproductChange =(index) => (event, values) => {	
	 let discal=0,strdisamt=0,costdiscnt=0;
if( values.rowindex!=="-1"){
	 let id = index;
	let optionsRep = this.state.pvdata;
   optionsRep.sort((a, b) => a.rowindex > b.rowindex ? 1 : -1).forEach(eachrep => {
       if (eachrep.rowindex === id)
	   {
let strtaxvalue=((parseFloat( values["salesprice"])*Number(1))*parseFloat( values["taxper"]))/100;
  let stramount=(parseFloat( values["salesprice"])*Number(1))+parseFloat(strtaxvalue);
 let strdisamt=(parseFloat(values["salesprice"])-parseFloat(discal));
  let strcosttaxvalue=(((parseFloat( values["pr_costprice"])*Number(1))*parseFloat( values["taxper"]))/100).toFixed(2);
  let strcostamount=(parseFloat( values["pr_costprice"])*Number(1))+parseFloat(strtaxvalue);
 let strcostdisamt=(parseFloat(values["pr_costprice"])-parseFloat(discal));
			   eachrep.pr_code= values["pr_code"];
			   eachrep.pr_description= values["pr_description"];
		       eachrep.salesprice= parseFloat(values["salesprice"]).toFixed(2);
			   eachrep.costtotal= parseFloat(strcostdisamt).toFixed(2);
			    eachrep.pr_costprice= parseFloat(values["pr_costprice"]).toFixed(2);
			   eachrep.pr_quantityinhand= values["pr_quantityinhand"];
		       eachrep.tax= (strtaxvalue).toFixed(2);			  
			   eachrep.pr_tx_id= values["pr_tax_id"]+"~"+values["taxper"];
		       eachrep.le_ledgername=this.state.le_ledgername;
		       eachrep.qty= "1"; 
			   eachrep.taxid= values["pr_tax_id"];
			   eachrep.pr_id=values["year"];
			   eachrep.esprodid=values["year"];
			    eachrep.taxper=values["taxper"];
			   eachrep.proddiscount= values["discount"];
		    eachrep.pr_isdeleted= "0";
			 eachrep.prodsel= values;
		     eachrep.proddiscount=discal;
		      eachrep.unit= values["pr_unit"];
		   eachrep.total= parseFloat(stramount).toFixed(2);
		 //   eachrep.amount= Number(stramount).toFixed(2);
		    eachrep.amount= Number(strdisamt).toFixed(2);
	}
    })
	id=parseFloat(id)+1;
this.setState({pvdata: optionsRep.concat([{"rowindex":id,"pr_id":"","iop_id":"0","esprodid":"","pr_code":"","pr_description":"","le_ledgername":this.state.primaryledgerid,"qty":"1","pr_costprice":"0.00","tax":"0.00","pr_tx_id":"","discount":"0.00","popdiscount":"0.00","popdiscountper":"0.00","discpoppnl":"0","pr_isdeleted":"0","taxper":"0.00","taxid":this.state.primarytaxid,"salesprice":"0.00","costtotal":"0","prodsel":[],
	"total":"0.00",showField: id}]), selectedproduct:values},()=>{this.Taxcalculate();})	
 }
  }
 onTagsproductexchange = (event, values) => {
	if(values!==" " && values!==null){
		this.setState({
		prodid:values.year,
	title:values.title,
	pr_code:values.pr_code,
		   description:values.pr_description,
		  ledgername:values.le_ledgername,
		  quantity:values.pr_quantity,
          price:values.price,
		selectedproduct:values},()=>{})
	}
	else
	{
		 this.setState({ prodid:'',pr_id:'',selectedproduct:[]})
	}
}
 handledraft=(e)=>{
	this.setState({isdraft: !this.state.isdraft}); 
 }
  taxbind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_mainid=0&sorting=tx_id')
      .then((resp) => {   
	  let TaxApi = resp.data.map(row => {
          return {value: row.tx_id+"~"+row.dwt_percentage, display:row.taxs}
        });
		 this.setState({primarytaxid:resp.data[0]["tx_id"],
          taxdata: TaxApi
        },()=>{
			this.Usergetdata();  
			});
      }).then(data => {       
      })
}
    ledgerbind(){
    axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_issales=1')
      .then((resp) => {   
	  let LedgerApi = resp.data.map(row => {
          return {value: row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: LedgerApi
        },()=>{this.taxbind();});
      })
}
onRowdelete(prid,rowindex){
	let r = window.confirm("Are you sure to Delete?");
		 if(r == true){
			const updatedArray = [...this.state.pvdata]; 
			if(updatedArray[rowindex].pr_id!=="")
			{				
			 updatedArray[rowindex].pr_isdeleted = "1";	
			  this.setState({pvdata: updatedArray,},()=>{this.Taxcalculate();});
			}else{
				alert("You can not delete this row");
				return false;
			}
		 }
}
Taxcalculate(){
	let optionstaxRep = this.state.pvdata.filter(value => value.pr_isdeleted !== "1");
	let profit=0.00,strsubtotal=0.00,strdiscount=0.00,self=this;;
	let  strgrantotal=0,strtotaldiscount=0;
let strtaxid="",strsep="";
const arr = optionstaxRep;
const out = {};
for (const { salesprice,qty,discount, taxid,tax } of arr) {
  out[taxid] ??= { taxid, total: 0,taxamt:0 };
  const subtotal = out[taxid].total + ((parseFloat(salesprice)* parseFloat(qty))-parseFloat(discount));
   const taxtotal = out[taxid].taxamt + Number(tax);
   strtaxid=strtaxid+strsep+taxid;
		strsep=",";
  out[taxid] = { ...out[taxid], total: subtotal,taxamt:taxtotal };
}
self.onSelectedTaxbyid(strtaxid,out);
    optionstaxRep.forEach(eachrep => {
		  if(  eachrep.pr_isdeleted === "0" && eachrep.pr_description !== "" ){
			strsubtotal =parseFloat(strsubtotal)+(parseFloat(eachrep.salesprice)* parseFloat(eachrep.qty))-parseFloat(eachrep.discount)
	strgrantotal=parseFloat(strgrantotal)+parseFloat(eachrep.total)
		profit=parseFloat(profit)+parseFloat(eachrep.costtotal)
		strdiscount=parseFloat(strdiscount)+parseFloat(eachrep.discount)	
		  }
	});
	strgrantotal=parseFloat(strgrantotal)+parseFloat(this.state.salesshippingamt)
	 this.setState({taxsumarr:out,subtotal:parseFloat(strsubtotal).toFixed(2),grandtotal:parseFloat(strgrantotal).toFixed(2),profit:(parseFloat(strsubtotal)-parseFloat(profit)).toFixed(2),salesdiscount:strdiscount});
}
onFileChange=(e) =>{
	 let imageFile = e.target.files[0];
	   this.setState({ sin_file: e.target.files })
  if (!imageFile.name.match(/\.(png|jpeg|jpg|pdf)$/)) {
  this.setState({errormessage:"Please Upload Valid file (png,jpeg,jpg,pdf).",open:true});
		 window.scrollTo({top: 0})
    return false;
  }else{
        this.setState({ sin_file: e.target.files })
  }
    }
onClickSalesSave= (event) => {
	let sin_id;
	 let cuid = this.state.cuid,
	 invoicedate1 = this.state.invoicedate1,
	 invoiceduedate1 = this.state.invoiceduedate1,
	 billingaddress1 = this.state.billingaddress1,
	 billingaddress2 = this.state.billingaddress2,
	 billingcity = this.state.billingcity,
	 billingstate = this.state.billingstate,
	 billingpincode = this.state.billingpincode,
	shippingaddress1 = this.state.shippingaddress1,
	shippingaddress2 = this.state.shippingaddress2,
	shippingcity = this.state.shippingcity,
	shippingstate = this.state.shippingstate,
	shippingpincode = this.state.shippingpincode,
	termscond = this.state.termscond,
	comments = this.state.comments,
	salesshippingamt = this.state.salesshippingamt,
	salesdiscount = this.state.salesdiscount,
	reference = this.state.reference,
	sin_file=this.state.sin_file,estimateid=this.state.estimateid
	;
	//let strtotal=parseFloat(this.state.paybalamt)+parseFloat(this.state.grandtotal);
	let strtotal=parseFloat(this.state.grandtotal);
	if (this.state.copy=="1")
	{			
		sin_id=0;
	}
	else{			
		sin_id= this.state.sin_id;
	}
	let optionsVal = this.state.pvdata;
		let sep1="",strdraft="2";
		let optionValues="";
		let index=0;
		if(this.state.isdraft===true)
		{
			strdraft="1";
		}
	var srearray=optionsVal.filter(value => value.op_isdeleted  < 1)
		 if(cuid === "")
	 {		 
		 this.setState({errormessage:"Please Select Customer",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
	 }	
		 if(invoicedate1 === "")
	 {		 
		 this.setState({errormessage:"Please Select Invoice Date",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
	 }		
	if(invoiceduedate1 === "")
	 {		 
		 this.setState({errormessage:"Please Select Invoice Due Date",erropen:true,});
		 window.scrollTo({top: 0})
		 return false
	 }
	 if(srearray.length-1 === 0)	
		{
	 this.setState({errormessage:"Please Select Product ",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		}
	 if(optionsVal.length === 1)
	 {
		 this.setState({errormessage:"Please Select Product ",erropen:true,});
		 window.scrollTo({ top: 0})
		 return false;
	 }
		let optionisdeledValues="";
let sep2="";  
	 optionsVal.forEach(eachval => {
		 if(eachval.pr_description!=""){  
	   if(eachval.pr_isdeleted==="1")
	   {
		     optionisdeledValues=optionisdeledValues+sep2+eachval.iop_id;
		 sep2=","
	   }
	   else
	   {
 optionValues=optionValues+sep1+eachval.pr_id+"~"+eachval.pr_description+"~"+eachval.le_ledgername+"~"+eachval.qty+"~"+eachval.taxid+"~"+eachval.salesprice+"~"+eachval.discount+"~"+eachval.tax+"~"+eachval.total+"~"+eachval.iop_id+"~"+eachval.pr_costprice+"~"+eachval.pr_code+"~"+eachval.taxper;
 sep1="`"; 
	   }
		 }
    })
	this.setState({btndisabled:false})
var formData = new FormData();
		formData.append('action','insertorupdate')	
formData.append('sin_id',sin_id) 
formData.append('estimateid',estimateid) 
formData.append('paymentbalamt',strtotal)
formData.append('sin_cu_id',cuid) 
formData.append('sin_invoicedate',invoicedate1) 
formData.append('sin_invoiceduedate',invoiceduedate1) 
formData.append('sin_reference',reference)
formData.append('sin_discount',salesdiscount)
formData.append('sin_billingaddress1',billingaddress1)
formData.append('sin_billingaddress2',billingaddress2)
formData.append('sin_billingcity',billingcity)
formData.append('sin_billingstate',billingstate)
formData.append('sin_billingpincode',billingpincode)
formData.append('sin_shippingcharges',salesshippingamt)
formData.append('sin_status',strdraft)	
formData.append('sin_invoiceno',"")	
formData.append('sin_shippingaddress1',shippingaddress1)
formData.append('sin_shippingaddress2',shippingaddress2)	
formData.append('sin_shippingcity',shippingcity)
formData.append('sin_shippingstate',shippingstate)
formData.append('sin_shippingpincode',shippingpincode)
formData.append('sin_pdffile','')
	if(sin_file!=="")
	  {
		for (const key of Object.keys(this.state.sin_file)) {
            formData.append('Filedata', this.state.sin_file[key])
        }
	   formData.append('sin_file','1')		
	  }else
	  {
		 formData.append('sin_file',this.state.previocn)	  
	  }	
	  if(optionisdeledValues!=="")
	{
    formData.append('prodisdelet',optionisdeledValues)	
	}
	else
	{
		 formData.append('prodisdelet',"")	
	}
formData.append('sin_comments',comments)	
formData.append('sin_termsandconditions',termscond)
formData.append('sin_cmp_id',localStorage.getItem("ISIcmpid"))
formData.append('userid',localStorage.getItem("ISIuserid"))
formData.append('invoiceproducts',optionValues)
 axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
        }).then(res => {
			var strreturn=res.data;
			if(strreturn!==-1)
			{
			if(this.state.sin_id===0)
			{
				this.setState({btndisabled:false,submitbtn:"Save",errortype:"success",errormessage:"Sales Invoice created Successfully",cuid:"",comments:'',termscond:'',reference:'',salesdiscount:0.00,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',salesshippingamt:0.00,isdraft:false,shippingaddress1:'',erropen:true,shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',})
			}
			else{
				if(this.state.copy==='')
			{
				this.setState({redirect:true,pagename:'/Salesinvoiceviewmore?sinoid='+this.state.sin_id});
			}else{
					this.setState({btndisabled:false,submitbtn:"Save",errortype:"success",errormessage:"Sales Invoice created Successfully",cuid:"",comments:'',termscond:'',reference:'',salesdiscount:0.00,billingaddress1:'',billingaddress2:'',billingcity:'',billingstate:'',billingpincode:'',salesshippingamt:0.00,isdraft:false,shippingaddress1:'',erropen:true,shippingaddress2:'',shippingcity:'',shippingstate:'',shippingpincode:'',})
			}
			}
			this.Usergetdata();
			}
			else{
				this.setState({
errormessage: `Customer Credit Limit Exceeds $${this.state.cu_creditlimit}`,					errortype:"error",
					erropen:true,}); window.scrollTo({top: 0})
			}
		});
}
  render() { 
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  return (
		<React.Fragment> 
		<div className="contenttext">
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
		<ul>
		<li>
		<p><span className="validation">*</span>Search for a Customer</p>
		<p>
			<Autocomplete
			  id="free-solo-demo"
			  className="txtbox"  inputValue={this.state.custid}
			  options={this.state.customerrauto}   onInputChange={this.onInputCustChange}
			   onChange={this.onTagscustomerexchange} 
				value={this.state.selectedcustomerexchange}
			  renderInput={(params) => (
				<TextField {...params} className="txtbox" onChange={this.onloadCustomerBind}  variant="outlined" />
			  )}
		 getOptionLabel={(option) => option.title || ""}
        renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
              </tr> )}
			   {option.rowindex=="-1" &&(
			    <tr {...props}>
                <td width='10%' onClick={this.handleCustomerInsertpopup}><span className='addautoextender' ><AddIcon />{option.title}</span></td>
              </tr>
			   )}
            </tbody>
          </table>
        </React.Fragment>
      )}
    />
	{(this.state.paybalamt!=0 && this.state.paybalamt!="0" ) && (
	<span className="balnacemt">Out Standing Amount {this.state.paybalamt}</span>
	)}
	</p>
	<AddCustomerbox ref="AddCustomerbox" id={0}  updatecustomer={this.insertcustomerParent}/>	
</li>
<li>  <p><span className="validation">*</span>Invoice Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.invoicedate) }
      className="txtbox" 
      onChange={this.handleinvoicedate} format="MM/DD/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p>
</li>
<li><p><span className="validation">*</span>Due date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.invoiceduedate) }  minDate={dayjs(this.state.invoiceduedate)}
      className="txtbox"  inputProps={{tabIndex: "3"}}
      onChange={this.handleinvoiceduedate} format="MM/DD/YYYY"
   />  </DemoContainer>
    </LocalizationProvider></p></li>
	<li><p>Reference</p>
		<p> <TextField name="reference" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    value={this.state.reference}
			inputProps={{tabIndex: "4",maxLength:150}} className="txtbox" 
	    InputLabelProps={{ shrink: true }}
                          /></p> </li>
{this.state.billingaddress1!="" && (	
	<React.Fragment>
	<li>
<div className="addresleft">
<h6>Main Address</h6>
<p>
{this.state.billingaddress1},
{this.state.billingaddress2},<br/>
{this.state.billingcity},
{this.state.billingstate},<br/>
{this.state.billingpincode}
<Customerbilling ref="BillingAddCustomerbox" id={this.state.cuid}  billingupdateDone={this.updateDonenewParent}/>	
</p>		
</div><div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.Customerbillingaddbox(this.state.cuid)}}><EditIcon /></span>
</div>
</li><li>
<div className="addresleft">
<h6>Delivery Address</h6>
<p>
{this.state.shippingaddress1},
{this.state.shippingaddress2},<br/>
{this.state.shippingcity},
{this.state.shippingstate},<br/>
{this.state.shippingpincode}
<Customershipping ref="ShippingAddCustomerbox" id={this.state.cuid}  shippingupdateDone={this.updateDonenewParent}/>	
</p>
</div><div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.Customershippingaddbox(this.state.cuid)}}><EditIcon /></span>
</div></li>
</React.Fragment>)}
</ul>
</div>
<div className="ordtbl">
<Paper className={useStyles.root}>
 <TableContainer className={useStyles.container}>  
 <Table stickyHeader aria-label="sticky table"> 
 <TableHead> 
<TableRow>   <TableCell width="5%"></TableCell> 
  <TableCell width="15%"><b>Product/Service</b></TableCell>     
  <TableCell width="20%"><b>Item Descriptions</b></TableCell>  
  <TableCell width="10%"><b>Ledger Name</b></TableCell> 
 <TableCell width="6%"><b>Qty</b></TableCell>  
  <TableCell width="6%"><b>Price</b></TableCell>   
  <TableCell width="5%" ><b>Discount</b></TableCell>  
  <TableCell width="15%"><b>Tax Rate</b></TableCell>  
    <TableCell width="10%"><b>Tax</b></TableCell> 
   <TableCell width="10%"><b>Total</b></TableCell> 
</TableRow ></TableHead>
                      <TableBody>
 {(this.state.pvdata).map((item,index) => {
           return ( <React.Fragment>
		   {item.pr_isdeleted!=="1" && (	 
 <TableRow key={index} >
<TableCell align="right">
  {item.pr_id!=="" && (
 <Tooltip title="Delete">
 <IconButton aria-label="Delete">
  <div className="secondary">
 <DeleteIcon onClick={()=>{this.onRowdelete(item.pr_id,index)}}/>
 </div>
 </IconButton>
 </Tooltip>
  )}
 </TableCell>
<TableCell>
 <p><Autocomplete
      id="free-solo-demo"
       className="txtbox"
	inputValue={item.esprodid}
		   onInputChange={this.onInputprodChange(index)}
		   onChange={this.onTagsproductChange(index)} 
	    value={item.prodsel}
      options={this.state.prodarrauto}
      renderInput={(params) => (
        <TextField {...params} onChange={this.onloadProductsBind}  variant="outlined" />
      )}
      getOptionLabel={(option) => option.title || ""}
  renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
              </tr> )}
			   {option.rowindex=="-1" &&(
			    <tr {...props}>
                <td width='10%' onClick={this.handlAddProductopen}><span className='addautoextender' ><AddIcon />{option.title}</span></td>
              </tr>
			   )}
            </tbody>
          </table>
        </React.Fragment>
      )}
    /></p>
 </TableCell>  
<TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.pr_description}
            id="description"
            onBlur={this.onEntertitle(index)}
            name="pr_description"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength:150
  }}
		 />
</TableCell>   
<TableCell>
<FormControl   className="txtbox">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.ledgerlabel, value: this.state.ledger}}
          onChange={this.myChangeHandlerPV(index)}
          id="ledger"
		   value={item.le_ledgername} className="txtbox"
		  name="le_ledgername"
		inputProps={{tabIndex: "8"}}
        >
		{this.state.ledgerdata.map(ledger => (
            <option  
              value={ledger.value}
            >
              {ledger.display}
            </option  >
          ))}
        </Select></FormControl>
</TableCell>   
<TableCell>
<TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.qty}
            id="qty"           
			inputRef={element => (this.textRef = element)}
            name="qty"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
		 />
</TableCell>  
<TableCell>
  <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={Number(item.salesprice).toFixed(2)}
            id="price"          
            name="salesprice" onChange={this.myChangeHandlerPV(index)}
            autoComplete="price"/>
</TableCell> 
<TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.discount}
           // id="discount"
           id="inputwidth"
			//type="number"
            name="discount" onClick={this.Discountelement(index)}
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
		 />
		 {item.discpoppnl==="1" && (
<div className="Eachrowdiscount" onBlur={this.Discountpanelhide(index)}><div className="discounttooltip">
<div className="disnct-sol1">
 Amount:  </div><div className="disnct-sol2">
		< TextField
            variant="outlined"  margin="normal"  className="txtbox"
            halfWidth value={item.popdiscount} id="popdiscount" 
            name="popdiscount"  onChange={this.myChangeHandlerPV(index)} inputProps={{ maxLength: 4}}/>
	 </div><div className="disnct-sol3">
		< TextField
            variant="outlined"  margin="normal"  className="txtbox"
            halfWidth value={item.popdiscountper} id="popdiscountper" 
            name="popdiscountper"  onChange={this.myChangeHandlerPV(index)} inputProps={{ maxLength: 4}}
				 slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            },
          }}
			/>
 </div> <div className="clear"></div></div></div>
		 )}
</TableCell> 
 <TableCell>
 <FormControl   className="txtbox">
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.taxlabel, value: this.state.pr_tx_id}}
          onChange={this.myChangeHandlerPV(index)}
          id="tax"
		   value={item.pr_tx_id}
		  name="pr_tx_id"
		inputProps={{tabIndex: "8"}}
        >
		{this.state.taxdata.map(tax => (
            <option  
              value={tax.value}
            >
              {tax.display}
            </option>
          ))}
        </Select></FormControl>
</TableCell> 
<TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.tax}
          disabled
           id="inputwidth"
            name="tax"
			onChange={this.myChangeHandlerPV(index)}
          inputProps={{
    maxLength: 5
  }}
		 />
</TableCell> 
<TableCell>
   <TextField
            variant="outlined"
            margin="normal"           
            fullWidth 
			className="txtbox"
			value={item.total}
            id="taxval"          
            name="taxval" 
            autoComplete="taxval"/>	 
</TableCell> 
 </TableRow>
)}
				</React.Fragment>	
				);
					})}					  
	 </TableBody>
</Table>
  </TableContainer> 
  </Paper>	
<div className="salesmodulecal">
<div className="first-col"><p>Comments</p><p>
 <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={this.state.comments}
            id="taxval" multiline rows={3}         
            name="comments" onChange={this.myChangeHandler}
            autoComplete="taxval"/>	 
</p>
</div>
<div className="first-col"><p>Terms and Conditions</p><p>
 <TextField
            variant="outlined"
            margin="normal"           
            fullWidth  className="txtbox"
			value={this.state.termscond}
            id="taxval" multiline rows={3}         
            name="termscond" onChange={this.myChangeHandler}
            autoComplete="taxval"/>	 
</p>
</div>
<div className="first-col">
<p className="popformtext">Shipping Charges</p>
		<p className="popforminputs">
		  <TextField
            variant="outlined"
            margin="normal"
           className="txtbox"
            fullWidth
			value={this.state.salesshippingamt}
            id="billingaddress1"
          inputProps={{tabIndex: "1",maxLength:6}}
            name="salesshippingamt" onChange={this.myChangeHandler}
            autoComplete="billingaddress1" /></p>	
			<div className="clear"></div>
	<p className="popformtext">Discount</p>
		<p className="popforminputs">
		 <b>{this.state.salesdiscount} </b></p>	
			<div className="clear"></div>	  
		<p className="popformtext">Subtotal</p> <p className="popforminputs"><b>{Number(this.state.subtotal).toFixed(2)}</b> </p> 
		<div className="clear"></div>
		{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		<div className="taxdiv">
{this.state.taxbrkupsarr.map((rows,i) => {
  return (
    <React.Fragment key={i}>
      <p className="popformtext">
        <b>{rows.taxname} @ {rows.taxper}%</b>
      </p>
      <p className="popforminputs">
       <b>{Number(rows.taxamt).toFixed(2)}</b>
      </p>
      <div className="clear"></div>
    </React.Fragment>
  );
})}
	</div></React.Fragment>
		)}
		<p className="popformtext">Total</p> <p className="popforminputs"><b>{this.state.grandtotal}</b> </p> 
		<div className="clear"></div>
		<p className="popformtext">Profit</p> <p className="popforminputs"><b>{this.state.profit}</b></p> 
		<div className="clear"></div>
</div>
<div className="clear"></div>
<Checkbox {...label} value={this.state.isdraft}   onChange={this.handledraft} color="default" />  Save as draft
</div>  
   <div className="salesactions">
   <p>
   <Button component="label"  className="frmSecondarybtn" name="st_profile"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<AttachmentIcon />}>
		Add File
		<VisuallyHiddenInput type="file"   /></Button>
		{this.state.previocn!="" && (
		<p><a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.previocn} target="_blank">View</a></p>
		)}
		&nbsp;
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>
   </div>
   <div className="clear"></div>
	</div>
<Addproducts ref="Addproducts" prodid={0}  updateprodnew={this.updatProductParent}/>
</React.Fragment>
  );
  }
}